/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { centerSalaryControllerCreate } from '../fn/center-salary/center-salary-controller-create';
import { CenterSalaryControllerCreate$Params } from '../fn/center-salary/center-salary-controller-create';
import { centerSalaryControllerDelete } from '../fn/center-salary/center-salary-controller-delete';
import { CenterSalaryControllerDelete$Params } from '../fn/center-salary/center-salary-controller-delete';
import { centerSalaryControllerFindById } from '../fn/center-salary/center-salary-controller-find-by-id';
import { CenterSalaryControllerFindById$Params } from '../fn/center-salary/center-salary-controller-find-by-id';
import { centerSalaryControllerFindByMonth } from '../fn/center-salary/center-salary-controller-find-by-month';
import { CenterSalaryControllerFindByMonth$Params } from '../fn/center-salary/center-salary-controller-find-by-month';
import { centerSalaryControllerGetConfirmedSalaries } from '../fn/center-salary/center-salary-controller-get-confirmed-salaries';
import { CenterSalaryControllerGetConfirmedSalaries$Params } from '../fn/center-salary/center-salary-controller-get-confirmed-salaries';
import { centerSalaryControllerGetTicketAmountByDate } from '../fn/center-salary/center-salary-controller-get-ticket-amount-by-date';
import { CenterSalaryControllerGetTicketAmountByDate$Params } from '../fn/center-salary/center-salary-controller-get-ticket-amount-by-date';
import { centerSalaryControllerGetTicketAmountByMonth } from '../fn/center-salary/center-salary-controller-get-ticket-amount-by-month';
import { CenterSalaryControllerGetTicketAmountByMonth$Params } from '../fn/center-salary/center-salary-controller-get-ticket-amount-by-month';
import { centerSalaryControllerSearch } from '../fn/center-salary/center-salary-controller-search';
import { CenterSalaryControllerSearch$Params } from '../fn/center-salary/center-salary-controller-search';
import { centerSalaryControllerSettlement } from '../fn/center-salary/center-salary-controller-settlement';
import { CenterSalaryControllerSettlement$Params } from '../fn/center-salary/center-salary-controller-settlement';
import { centerSalaryControllerUpdate } from '../fn/center-salary/center-salary-controller-update';
import { CenterSalaryControllerUpdate$Params } from '../fn/center-salary/center-salary-controller-update';
import { CenterSalaryDto } from '../models/center-salary-dto';
import { CenterUserTicketAmountDto } from '../models/center-user-ticket-amount-dto';
import { ConfirmSalaryDto } from '../models/confirm-salary-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class CenterSalaryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `centerSalaryControllerSearch()` */
  static readonly CenterSalaryControllerSearchPath = '/api/center-salary';

  /**
   * 센터 급여 검색
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerSalaryControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerSalaryControllerSearch$Response(params: CenterSalaryControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return centerSalaryControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 급여 검색
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerSalaryControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerSalaryControllerSearch(params: CenterSalaryControllerSearch$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.centerSalaryControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `centerSalaryControllerCreate()` */
  static readonly CenterSalaryControllerCreatePath = '/api/center-salary';

  /**
   * 센터 급여 생성
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerSalaryControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  centerSalaryControllerCreate$Response(params: CenterSalaryControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterSalaryDto>> {
    return centerSalaryControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 급여 생성
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerSalaryControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  centerSalaryControllerCreate(params: CenterSalaryControllerCreate$Params, context?: HttpContext): Observable<CenterSalaryDto> {
    return this.centerSalaryControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterSalaryDto>): CenterSalaryDto => r.body)
    );
  }

  /** Path part for operation `centerSalaryControllerDelete()` */
  static readonly CenterSalaryControllerDeletePath = '/api/center-salary';

  /**
   * 센터 급여 삭제
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerSalaryControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerSalaryControllerDelete$Response(params: CenterSalaryControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return centerSalaryControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 급여 삭제
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerSalaryControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerSalaryControllerDelete(params: CenterSalaryControllerDelete$Params, context?: HttpContext): Observable<boolean> {
    return this.centerSalaryControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `centerSalaryControllerGetTicketAmountByMonth()` */
  static readonly CenterSalaryControllerGetTicketAmountByMonthPath = '/api/center-salary/ticket-amount/month';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerSalaryControllerGetTicketAmountByMonth()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerSalaryControllerGetTicketAmountByMonth$Response(params: CenterSalaryControllerGetTicketAmountByMonth$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterUserTicketAmountDto>> {
    return centerSalaryControllerGetTicketAmountByMonth(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerSalaryControllerGetTicketAmountByMonth$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerSalaryControllerGetTicketAmountByMonth(params: CenterSalaryControllerGetTicketAmountByMonth$Params, context?: HttpContext): Observable<CenterUserTicketAmountDto> {
    return this.centerSalaryControllerGetTicketAmountByMonth$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterUserTicketAmountDto>): CenterUserTicketAmountDto => r.body)
    );
  }

  /** Path part for operation `centerSalaryControllerGetTicketAmountByDate()` */
  static readonly CenterSalaryControllerGetTicketAmountByDatePath = '/api/center-salary/ticket-amount/date';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerSalaryControllerGetTicketAmountByDate()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerSalaryControllerGetTicketAmountByDate$Response(params: CenterSalaryControllerGetTicketAmountByDate$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterUserTicketAmountDto>> {
    return centerSalaryControllerGetTicketAmountByDate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerSalaryControllerGetTicketAmountByDate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerSalaryControllerGetTicketAmountByDate(params: CenterSalaryControllerGetTicketAmountByDate$Params, context?: HttpContext): Observable<CenterUserTicketAmountDto> {
    return this.centerSalaryControllerGetTicketAmountByDate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterUserTicketAmountDto>): CenterUserTicketAmountDto => r.body)
    );
  }

  /** Path part for operation `centerSalaryControllerGetConfirmedSalaries()` */
  static readonly CenterSalaryControllerGetConfirmedSalariesPath = '/api/center-salary/confirm';

  /**
   * 확정 급여 조회
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerSalaryControllerGetConfirmedSalaries()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerSalaryControllerGetConfirmedSalaries$Response(params: CenterSalaryControllerGetConfirmedSalaries$Params, context?: HttpContext): Observable<StrictHttpResponse<ConfirmSalaryDto>> {
    return centerSalaryControllerGetConfirmedSalaries(this.http, this.rootUrl, params, context);
  }

  /**
   * 확정 급여 조회
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerSalaryControllerGetConfirmedSalaries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerSalaryControllerGetConfirmedSalaries(params: CenterSalaryControllerGetConfirmedSalaries$Params, context?: HttpContext): Observable<ConfirmSalaryDto> {
    return this.centerSalaryControllerGetConfirmedSalaries$Response(params, context).pipe(
      map((r: StrictHttpResponse<ConfirmSalaryDto>): ConfirmSalaryDto => r.body)
    );
  }

  /** Path part for operation `centerSalaryControllerFindByMonth()` */
  static readonly CenterSalaryControllerFindByMonthPath = '/api/center-salary/month';

  /**
   * 센터 급여 상세 조회
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerSalaryControllerFindByMonth()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerSalaryControllerFindByMonth$Response(params: CenterSalaryControllerFindByMonth$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterSalaryDto>> {
    return centerSalaryControllerFindByMonth(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 급여 상세 조회
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerSalaryControllerFindByMonth$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerSalaryControllerFindByMonth(params: CenterSalaryControllerFindByMonth$Params, context?: HttpContext): Observable<CenterSalaryDto> {
    return this.centerSalaryControllerFindByMonth$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterSalaryDto>): CenterSalaryDto => r.body)
    );
  }

  /** Path part for operation `centerSalaryControllerFindById()` */
  static readonly CenterSalaryControllerFindByIdPath = '/api/center-salary/{id}';

  /**
   * 센터 급여 상세 조회
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerSalaryControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerSalaryControllerFindById$Response(params: CenterSalaryControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterSalaryDto>> {
    return centerSalaryControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 급여 상세 조회
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerSalaryControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerSalaryControllerFindById(params: CenterSalaryControllerFindById$Params, context?: HttpContext): Observable<CenterSalaryDto> {
    return this.centerSalaryControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterSalaryDto>): CenterSalaryDto => r.body)
    );
  }

  /** Path part for operation `centerSalaryControllerUpdate()` */
  static readonly CenterSalaryControllerUpdatePath = '/api/center-salary/{id}';

  /**
   * 센터 급여 수정
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerSalaryControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  centerSalaryControllerUpdate$Response(params: CenterSalaryControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterSalaryDto>> {
    return centerSalaryControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 급여 수정
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerSalaryControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  centerSalaryControllerUpdate(params: CenterSalaryControllerUpdate$Params, context?: HttpContext): Observable<CenterSalaryDto> {
    return this.centerSalaryControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterSalaryDto>): CenterSalaryDto => r.body)
    );
  }

  /** Path part for operation `centerSalaryControllerSettlement()` */
  static readonly CenterSalaryControllerSettlementPath = '/api/center-salary/settlement';

  /**
   * 일괄 정산
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerSalaryControllerSettlement()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  centerSalaryControllerSettlement$Response(params: CenterSalaryControllerSettlement$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return centerSalaryControllerSettlement(this.http, this.rootUrl, params, context);
  }

  /**
   * 일괄 정산
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerSalaryControllerSettlement$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  centerSalaryControllerSettlement(params: CenterSalaryControllerSettlement$Params, context?: HttpContext): Observable<boolean> {
    return this.centerSalaryControllerSettlement$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
